import { Profiler } from '@eti/utils';
import PersuasionModalProvider from '../../common/context/PersuasionModalContext';
import SeatMapProductCard from './SeatMapProductCard';
import SeatMapDialog from './SeatMapDialog';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SeatMapProduct = _ref => {
  let {
    form,
    isSeatMapModalOpen,
    setIsSeatMapModalOpen
  } = _ref;
  const onClose = () => {
    setIsSeatMapModalOpen(false);
  };
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "SeatMapNewLayout",
    children: /*#__PURE__*/_jsx(Profiler, {
      id: "TravelerDetails-SeatMap",
      children: /*#__PURE__*/_jsxs(PersuasionModalProvider, {
        children: [/*#__PURE__*/_jsx(SeatMapProductCard, {
          form: form,
          setIsSeatMapModalOpen: setIsSeatMapModalOpen
        }), /*#__PURE__*/_jsx(SeatMapDialog, {
          onClose: onClose,
          show: isSeatMapModalOpen
        })]
      })
    })
  });
};
export default SeatMapProduct;